import gql from 'graphql-tag';

export const GET_CONFIGS = gql`
  query Configs {
    configs {
      key
      value
    }
  }
`;
